<ion-app>
  <ion-menu contentId="main-content" type="overlay">
    <ion-header class="ion-no-border">
      <ion-toolbar style="--background: #1e1e1e; padding-top: 15px;">
        
        <!-- 💡 ESTRUCTURA FLEXIBLE QUE ADAPTA EL BADGE EN CUALQUIER TAMAÑO DE PANTALLA DE TELÉFONO -->
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 15px 10px 15px;">
          
          <div style="display: flex; align-items: center; gap: 8px;">
            <ion-icon name="sunny-outline" style="color: #f4c130; font-size: 1.4rem;"></ion-icon>
            <span style="color: #f4c130; font-weight: bold; font-size: 1.3rem;">Solsun</span>
          </div>

          <!-- Badge Online/Offline visible sin recortes en móviles -->
          <ion-chip [color]="isOnline ? 'success' : 'danger'" style="height: 24px; font-weight: bold; font-size: 10px; margin: 0; padding: 0 8px;">
            <ion-icon [name]="isOnline ? 'wifi-outline' : 'cloud-offline-outline'" style="font-size: 12px; margin-right: 4px;"></ion-icon>
            <ion-label>{{ isOnline ? 'ONLINE' : 'OFFLINE' }}</ion-label>
          </ion-chip>

        </div>

      </ion-toolbar>
    </ion-header>

    <ion-content style="--background: #222222;">
      <ion-list style="background: transparent;" lines="none">
        
        <!-- DASHBOARD CENTRAL -->
        <ion-item button routerLink="/dashboard-page" routerDirection="root" color="dark" lines="none" style="margin-bottom: 15px; border-bottom: 1px solid #333;">
          <ion-icon slot="start" name="grid-outline" style="color: #f4c130;"></ion-icon>
          <ion-label style="font-weight: bold; font-size: 1.1rem;">Dashboard Central</ion-label>
        </ion-item>

        <!-- 🟣 VISTA EXCLUSIVA DE MARTHA (AUDITORÍA & CONTABILIDAD) -->
        <div *ngIf="esMartha()">
          <ion-list-header style="color: #f4c130; font-size: 12px; margin-top: 10px; font-weight: bold;">
            AUDITORÍA & CONTABILIDAD
          </ion-list-header>

          <ion-item button routerLink="/control-vehicular-dashboard" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="stats-chart-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Auditoría Vehicular & ZIP</ion-label>
          </ion-item>

          <ion-item button routerLink="/nueva-unidad" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="bus-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Flotilla de Vehículos</ion-label>
          </ion-item>

          <ion-item button routerLink="/tarjetas" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="card-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Tarjetas & Métodos de Pago</ion-label>
          </ion-item>

          <ion-item button routerLink="/registrar-carga" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="color-fill-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Cargar Combustible</ion-label>
          </ion-item>

          <ion-item button routerLink="/corte-kilometraje" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="speedometer-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Corte Kilometraje</ion-label>
          </ion-item>
        </div>

        <!-- 🟡 SECCIÓN EXCLUSIVA DEL ADMINISTRADOR MAESTRO -->
        <ng-container *ngIf="esAdminMaestro()">
          <ion-list-header style="color: #aaa; font-size: 12px; margin-top: 10px;">ADMINISTRACIÓN MAESTRA</ion-list-header>

          <ion-item routerLink="/usuarios" routerDirection="root" lines="none" color="dark">
            <ion-icon slot="start" name="people-outline" style="color: var(--ion-color-secondary);"></ion-icon>
            <ion-label>Directorio Usuarios</ion-label>
          </ion-item>

          <ion-item routerLink="/admin" routerDirection="root" lines="none" color="dark">
            <ion-icon slot="start" name="options-outline" style="color: var(--ion-color-secondary);"></ion-icon>
            <ion-label>Control Maestro</ion-label>
          </ion-item>

          <ion-item routerLink="/tarjetas" routerDirection="root" lines="none" color="dark">
            <ion-icon slot="start" name="card-outline" style="color: var(--ion-color-secondary);"></ion-icon>
            <ion-label>Tarjetas & Métodos de Pago</ion-label>
          </ion-item>

          <ion-item routerLink="/control-vehicular-dashboard" routerDirection="root" lines="none" color="dark">
            <ion-icon slot="start" name="stats-chart-outline" style="color: var(--ion-color-secondary);"></ion-icon>
            <ion-label>Auditoría Vehicular & ZIP</ion-label>
          </ion-item>

          <ion-item routerLink="/nueva-unidad" routerDirection="root" lines="none" color="dark">
            <ion-icon slot="start" name="bus-outline" style="color: var(--ion-color-secondary);"></ion-icon>
            <ion-label>Flotilla de Vehículos</ion-label>
          </ion-item>
        </ng-container>

        <!-- SECCIÓN DE VENTAS (OCULTA PARA MARTHA) -->
        <div *ngIf="(esVendedor() || esAdministrador()) && !esMartha()">
          <ion-list-header style="color: #aaa; font-size: 12px; margin-top: 10px;">VENTAS</ion-list-header>
          
          <ion-item button routerLink="/cotizador" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="calculator-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Cotizador de Proyectos</ion-label>
          </ion-item>

          <ion-item button routerLink="/cotizaciones" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="cash-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Cotizaciones</ion-label>
          </ion-item>

          <ion-item button routerLink="/catalogo-precios" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="library-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Catálogo de Precios</ion-label>
          </ion-item>

          <ion-item button routerLink="/vendedor" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="briefcase-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Mis Ventas</ion-label>
          </ion-item>

          <!-- 🟡 VISTAS DE COMBUSTIBLE Y KILOMETRAJE PARA CARLOS Y URIEL / VENDEDORES -->
          <ion-item button routerLink="/registrar-carga" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="color-fill-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Cargar Combustible</ion-label>
          </ion-item>

          <ion-item button routerLink="/corte-kilometraje" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="speedometer-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Corte Kilometraje</ion-label>
          </ion-item>

          <ion-item button routerLink="/lista-cubiertas" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="layers-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Solicitudes de Cubiertas</ion-label>
          </ion-item>
          
          <ion-item button routerLink="/nueva-orden" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="add-circle-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Nueva Orden</ion-label>
          </ion-item>

          <ion-item button routerLink="/visitas-lista" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="map-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Visitas / Levantamientos</ion-label>
          </ion-item>

          <ion-item button routerLink="/nueva-visita" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="calendar-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Agendar Visita</ion-label>
          </ion-item>

          <ion-item button routerLink="/abastecimiento-lista" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="cart-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Abastecimiento</ion-label>
          </ion-item>

          <ion-item button routerLink="/proveedores" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="business-outline" style="color: #f4c130;"></ion-icon>
            <ion-label>Directorio Proveedores</ion-label>
          </ion-item>
        </div>

        <!-- OPERACIONES Y COMPRAS (ALMACÉN, OCULTA PARA MARTHA) -->
        <div *ngIf="(esAlmacen() || esAdministrador()) && !esMartha()">
          <ion-list-header style="color: #aaa; font-size: 12px; margin-top: 10px;">OPERACIONES Y COMPRAS</ion-list-header>
          
          <ion-item button routerLink="/almacen" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="cube-outline" style="color: #2d6577;"></ion-icon>
            <ion-label>Surtido / Almacén</ion-label>
          </ion-item>

          <ion-item button routerLink="/lista-cubiertas" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="layers-outline" style="color: #2d6577;"></ion-icon>
            <ion-label>Solicitudes de Cubiertas</ion-label>
          </ion-item>

          <ion-item button routerLink="/abastecimiento-lista" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="cart-outline" style="color: #2d6577;"></ion-icon>
            <ion-label>Abastecimiento</ion-label>
          </ion-item>

          <ion-item button routerLink="/registrar-carga" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="color-fill-outline" style="color: #2d6577;"></ion-icon>
            <ion-label>Cargar Combustible</ion-label>
          </ion-item>

          <ion-item button routerLink="/corte-kilometraje" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="speedometer-outline" style="color: #2d6577;"></ion-icon>
            <ion-label>Corte Kilometraje</ion-label>
          </ion-item>

          <ion-item button routerLink="/proveedores" routerDirection="root" color="dark" lines="none">
            <ion-icon slot="start" name="business-outline" style="color: #2d6577;"></ion-icon>
            <ion-label>Directorio Proveedores</ion-label>
          </ion-item>
        </div>

        <!-- EN CAMPO (TÉCNICOS, OCULTA PARA MARTHA) -->
        <div *ngIf="(esTecnico() || esAdministrador()) && !esMartha()">
          <ion-list-header style="color: #aaa; font-size: 12px; margin-top: 10px;">EN CAMPO</ion-list-header>

          <ion-item button routerLink="/tecnico" routerDirection="root" color="dark">
            <ion-icon slot="start" name="construct-outline" style="color: #2dd36f;"></ion-icon>
            <ion-label>Mis Instalaciones</ion-label>
          </ion-item>

          <ion-item button routerLink="/registrar-carga" routerDirection="root" color="dark">
            <ion-icon slot="start" name="color-fill-outline" style="color: #2dd36f;"></ion-icon>
            <ion-label>Cargar Combustible</ion-label>
          </ion-item>

          <ion-item button routerLink="/corte-kilometraje" routerDirection="root" color="dark">
            <ion-icon slot="start" name="speedometer-outline" style="color: #2dd36f;"></ion-icon>
            <ion-label>Corte Kilometraje</ion-label>
          </ion-item>

          <ion-item button routerLink="/visitas-lista" routerDirection="root" color="dark">
            <ion-icon slot="start" name="navigate-outline" style="color: #2dd36f;"></ion-icon>
            <ion-label>Mis Visitas Asignadas</ion-label>
          </ion-item>
        </div>

      </ion-list>
    </ion-content>

    <ion-footer class="ion-no-border">
      <ion-toolbar style="--background: #1e1e1e;">
        <ion-button expand="block" fill="clear" color="danger" (click)="cerrarSesion()">
          <ion-icon name="log-out-outline" slot="start"></ion-icon>
          Cerrar Sesión
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>